import {
  REQUEST_USERS,
  RESPONSE_USERS,
  REQUEST_USERS_FAILURE,
  REQUEST_USER,
  RESPONSE_USER,
  REQUEST_USER_FAILURE,
  REQUEST_USER_BLOCK_STATES,
  RESPONSE_USER_BLOCK_STATES,
  REQUEST_USER_BLOCK_STATES_FAILURE,
  REQUEST_CREATE_USER,
  RESPONSE_CREATE_USER,
  REQUEST_CREATE_USER_FAILURE,
  REQUEST_CREATE_USER_PERMISSION,
  RESPONSE_CREATE_USER_PERMISSION,
  REQUEST_CREATE_USER_PERMISSION_FAILURE,
  REQUEST_DELETE_USER_PERMISSION,
  RESPONSE_DELETE_USER_PERMISSION,
  REQUEST_DELETE_USER_PERMISSION_FAILURE,
  REQUEST_CREATE_USER_OWNERSHIPAREA,
  RESPONSE_CREATE_USER_OWNERSHIPAREA,
  REQUEST_CREATE_USER_OWNERSHIPAREA_FAILURE,
  REQUEST_DELETE_USER_OWNERSHIPAREA,
  RESPONSE_DELETE_USER_OWNERSHIPAREA,
  REQUEST_DELETE_USER_OWNERSHIPAREA_FAILURE,
  CLEAR_CURRENT_USER,
  REQUEST_CREATE_USER_UNIT,
  RESPONSE_CREATE_USER_UNIT,
  REQUEST_CREATE_USER_UNIT_FAILURE,
  REQUEST_DELETE_USER_UNIT,
  RESPONSE_DELETE_USER_UNIT,
  REQUEST_DELETE_USER_UNIT_FAILURE,
  REQUEST_UPDATE_USER_PASSWORD,
  RESPONSE_UPDATE_USER_PASSWORD,
  REQUEST_UPDATE_USER_PASSWORD_FAILURE,
} from "../actions/usersActions";

import { states } from "./queriesStates";

const initialState = {
  usersDataState: states.NOT_REQUESTED,
  currentUserDataState: states.NOT_REQUESTED,
  blockStatesDataState: states.NOT_REQUESTED,
  createUserDataState: states.NOT_REQUESTED,
  userPermissionDataState: states.NOT_REQUESTED,
  userOwnershipAreaDataState: states.NOT_REQUESTED,
  createUserUnitDataState: states.NOT_REQUESTED,
  deleteUserUnitDataState: states.NOT_REQUESTED,
  updateUserPasswordDataState: states.NOT_REQUESTED,
  currentUser: null,
  users: [],
  errors: null,
};

const usersReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_USERS:
      return Object.assign({}, state, {
        usersDataState: states.REQUEST,
        uscoers: [],
      });
    case RESPONSE_USERS:
      return Object.assign({}, state, {
        usersDataState: states.READY,
        users: action.data.users,
      });
    case REQUEST_USERS_FAILURE:
      return Object.assign({}, state, {
        usersDataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_USER:
      return Object.assign({}, state, {
        currentUserDataState: states.REQUEST,
        currentUser: null,
      });
    case RESPONSE_USER:
      const users = state.users.map((x) => {
        if (x.id === action.data.id) {
          return action.data;
        }

        return x;
      });

      return Object.assign({}, state, {
        currentUserDataState: states.READY,
        currentUser: action.data,
        users: users,
      });
    case REQUEST_USER_FAILURE:
      return Object.assign({}, state, {
        currentUserDataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_USER_BLOCK_STATES:
      return Object.assign({}, state, {
        blockStatesDataState: states.REQUEST,
      });
    case RESPONSE_USER_BLOCK_STATES:
      const user = state.currentUser;
      user.isBlocked = action.data;

      return Object.assign({}, state, {
        blockStatesDataState: states.READY,
        currentUser: user,
      });
    case REQUEST_USER_BLOCK_STATES_FAILURE:
      return Object.assign({}, state, {
        blockStatesDataState: states.FAILURE,
        errors: action.errors.data,
      });

    case REQUEST_CREATE_USER:
      return Object.assign({}, state, {
        createUserDataState: states.REQUEST,
      });
    case RESPONSE_CREATE_USER:
      return Object.assign({}, state, {
        createUserDataState: states.READY,
      });
    case REQUEST_CREATE_USER_FAILURE:
      const errors = action.errors.data;
      let error = "Ошибка создания нового пользователя";
      if (errors.email) {
        error = errors.email[0];
      }

      if (errors.roleType) {
        error = errors.roleType[0];
      }

      return Object.assign({}, state, {
        createUserDataState: states.FAILURE,
        errors: error,
      });

    case REQUEST_CREATE_USER_PERMISSION:
      return Object.assign({}, state, {
        userPermissionDataState: states.REQUEST,
      });
    case RESPONSE_CREATE_USER_PERMISSION:
      const userCreatePermission = state.currentUser;

      userCreatePermission.classificationPermissions.forEach((classification) => {
        if (classification.classPermission === action.classPermission) {
          classification.permissions = classification.permissions.concat([action.data]);
        }
      });

      return Object.assign({}, state, {
        userPermissionDataState: states.READY,
        currentUser: userCreatePermission,
      });
    case REQUEST_CREATE_USER_PERMISSION_FAILURE:
      return Object.assign({}, state, {
        userPermissionDataState: states.FAILURE,
        errors: action.error,
      });

    case REQUEST_DELETE_USER_PERMISSION:
      return Object.assign({}, state, {
        userPermissionDataState: states.REQUEST,
      });
    case RESPONSE_DELETE_USER_PERMISSION:
      const userDeletePermission = state.currentUser;

      userDeletePermission.classificationPermissions.forEach((classification) => {
        if (classification.classPermission === action.classPermission) {
          classification.permissions = classification.permissions.filter((x) => {
            return x.id !== action.data.id;
          });
        }
      });

      return Object.assign({}, state, {
        userPermissionDataState: states.READY,
        currentUser: userDeletePermission,
      });
    case REQUEST_DELETE_USER_PERMISSION_FAILURE:
      return Object.assign({}, state, {
        userPermissionDataState: states.FAILURE,
        errors: action.errors.data,
      });

    case REQUEST_CREATE_USER_OWNERSHIPAREA:
      return Object.assign({}, state, {
        userOwnershipAreaDataState: states.REQUEST,
      });
    case RESPONSE_CREATE_USER_OWNERSHIPAREA:
      const createOwnershipArea = state.currentUser;
      createOwnershipArea.ownershipAreas = createOwnershipArea.ownershipAreas.concat([action.data]);

      return Object.assign({}, state, {
        userOwnershipAreaDataState: states.READY,
        currentUser: createOwnershipArea,
      });
    case REQUEST_CREATE_USER_OWNERSHIPAREA_FAILURE:
      return Object.assign({}, state, {
        userOwnershipAreaDataState: states.FAILURE,
        errors: action.errors.data,
      });

    case REQUEST_DELETE_USER_OWNERSHIPAREA:
      return Object.assign({}, state, {
        userOwnershipAreaDataState: states.REQUEST,
      });
    case RESPONSE_DELETE_USER_OWNERSHIPAREA:
      const deleteOwnershipAreas = state.currentUser;
      deleteOwnershipAreas.ownershipAreas = deleteOwnershipAreas.ownershipAreas.filter((x) => {
        return x.id !== action.data.id;
      });

      return Object.assign({}, state, {
        userOwnershipAreaDataState: states.READY,
        currentUser: deleteOwnershipAreas,
      });
    case REQUEST_DELETE_USER_OWNERSHIPAREA_FAILURE:
      return Object.assign({}, state, {
        userOwnershipAreaDataState: states.FAILURE,
        errors: action.errors.data,
      });

    case CLEAR_CURRENT_USER:
      return Object.assign({}, state, {
        currentUser: null,
      });

    case REQUEST_CREATE_USER_UNIT:
      return Object.assign({}, state, {
        createUserUnitDataState: states.REQUEST,
      });

    case RESPONSE_CREATE_USER_UNIT:
      const currentUserCreateUnit = state.currentUser;
      currentUserCreateUnit.units = currentUserCreateUnit.units.concat(action.data);

      return Object.assign({}, state, {
        createUserUnitDataState: states.READY,
        currentUser: currentUserCreateUnit,
      });

    case REQUEST_CREATE_USER_UNIT_FAILURE:
      return Object.assign({}, state, {
        createUserUnitDataState: states.FAILURE,
        errors: action.errors.data,
      });

    case REQUEST_DELETE_USER_UNIT:
      return Object.assign({}, state, {
        createUserUnitDataState: states.REQUEST,
      });

    case RESPONSE_DELETE_USER_UNIT:
      const currentUserDeleteUnit = state.currentUser;
      currentUserDeleteUnit.units = currentUserDeleteUnit.units.filter((x) => {
        return x.id !== action.data.id;
      });

      return Object.assign({}, state, {
        createUserUnitDataState: states.READY,
        currentUser: currentUserDeleteUnit,
      });

    case REQUEST_DELETE_USER_UNIT_FAILURE:
      return Object.assign({}, state, {
        createUserUnitDataState: states.FAILURE,
        errors: action.errors.data,
      });

    case REQUEST_UPDATE_USER_PASSWORD:
      return Object.assign({}, state, {
        updateUserPasswordDataState: states.REQUEST,
      });

    case RESPONSE_UPDATE_USER_PASSWORD:
      return Object.assign({}, state, {
        updateUserPasswordDataState: states.READY,
      });

    case REQUEST_UPDATE_USER_PASSWORD_FAILURE:
      return Object.assign({}, state, {
        updateUserPasswordDataState: states.FAILURE,
        errors: action.errors.data,
      });

    default:
      return state;
  }
};

export default usersReducer;
